import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';

const CONTACT_ITEMS = [
  {
    icon: <FaMapMarkerAlt size={18} />,
    label: 'Location',
    value: 'Hyderabad, India',
    href: null,
    color: '#00f5ff',
  },
  {
    icon: <FaPhoneAlt size={18} />,
    label: 'Phone',
    value: '+91 889 787 8118',
    href: 'tel:+918897878118',
    color: '#00ff88',
  },
  {
    icon: <FaEnvelope size={18} />,
    label: 'Email',
    value: 'abhiramgargeya08@gmail.com',
    href: 'https://mail.google.com/mail/?view=cm&fs=1&to=abhiramgargeya08@gmail.com',
    color: '#ff00de',
  },
];

const SOCIAL_LINKS = [
  {
    icon: <FaLinkedin size={22} />,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/abhiramgargeya/',
    color: '#00f5ff',
  },
  {
    icon: <FaGithub size={22} />,
    label: 'GitHub',
    href: 'https://github.com/AbhiramGarg/',
    color: '#ff00de',
  },
];

const Contact = () => (
  <section id="contact" className="py-20 px-2 pb-24">
    {/* Heading */}
    <div className="reveal mb-14 text-center">
      <p className="text-[#7c3aed] text-xs font-mono tracking-[0.25em] uppercase mb-2">
        // get in touch
      </p>
      <h2
        className="section-title text-4xl font-black mb-4"
        style={{
          background: 'linear-gradient(135deg, #7c3aed, #ff00de)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        Let's Connect
      </h2>
      <div
        className="neon-line w-28 mx-auto"
        style={{ background: 'linear-gradient(90deg, transparent, #7c3aed 50%, transparent)' }}
      />
    </div>

    <div className="max-w-3xl mx-auto">
      {/* Decorative SVG circuit-like pattern */}
      <div className="relative">
        <div className="absolute -top-6 -right-6 opacity-[0.06] pointer-events-none hidden md:block">
          <svg width="200" height="200" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="90" fill="none" stroke="#7c3aed" strokeWidth="1" strokeDasharray="8 4" />
            <circle cx="100" cy="100" r="60" fill="none" stroke="#ff00de" strokeWidth="0.8" />
            <circle cx="100" cy="100" r="30" fill="none" stroke="#7c3aed" strokeWidth="0.5" />
            <line x1="100" y1="10"  x2="100" y2="190" stroke="#7c3aed" strokeWidth="0.4" />
            <line x1="10"  y1="100" x2="190" y2="100" stroke="#7c3aed" strokeWidth="0.4" />
          </svg>
        </div>

        {/* Contact info cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
          {CONTACT_ITEMS.map(({ icon, label, value, href, color }, i) => (
            <div
              key={i}
              className="neon-card p-5 text-center reveal"
              style={{
                transitionDelay: `${i * 0.12}s`,
                borderColor: `${color}25`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = `${color}70`;
                e.currentTarget.style.boxShadow = `0 0 18px ${color}1a`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = `${color}25`;
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-3"
                style={{
                  color,
                  background: `${color}15`,
                  border: `1px solid ${color}40`,
                }}
              >
                {icon}
              </div>
              <p className="text-xs font-mono tracking-widest text-slate-500 uppercase mb-1">{label}</p>
              {href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-300 hover:text-white transition-colors break-all"
                  style={{ '--hover-color': color }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = color; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#cbd5e1'; }}
                >
                  {value}
                </a>
              ) : (
                <p className="text-sm text-slate-300">{value}</p>
              )}
            </div>
          ))}
        </div>

        {/* Social links */}
        <div className="flex justify-center gap-5 reveal" style={{ transitionDelay: '0.35s' }}>
          {SOCIAL_LINKS.map(({ icon, label, href, color }, i) => (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 neon-card px-6 py-3 text-sm font-mono tracking-wider transition-all duration-250"
              style={{ color: '#94a3b8', borderColor: `${color}30` }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = color;
                e.currentTarget.style.borderColor = color;
                e.currentTarget.style.boxShadow = `0 0 14px ${color}33`;
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#94a3b8';
                e.currentTarget.style.borderColor = `${color}30`;
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {icon}
              {label}
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
